import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import ConversationQueryTraversal from 'owa-service/lib/contract/ConversationQueryTraversal';
import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import FolderId from 'owa-service/lib/contract/FolderId';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import SortResults from 'owa-service/lib/contract/SortResults';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { findConversation } from './findConversation';
import { logLoadedConversationIds } from './utils/logFindMailResponse';
import { tryConsumeFindConversationResponse } from 'mini-mail-bootstrap/lib/sessionDataResponseStash';

/**
 * The FindConversationWithStartIndex is used today to load rows when we want to load them from the beginning (or 0th index)
 * This is currently used in load initial rows and in reload scenarios
 * @param folderId - The folderId for which we are fetching the data
 * @param startIndex - The index from where we want to fetch the rows
 * @param rowsToLoad - the number of rows to load
 * @param viewFilter - view filter (e.g - Unread\Flag)
 * @param sortResults - sort by properties
 * @param focusedViewFilter - whether focused view is on
 * @param findConversationShapeName - the shape for the request
 * @param shouldTryToUseSessionDataResponse - indicates if the call should try to use session data find conversation response
 * @param categoryFilter - the specific filter to use based on viewFilter
 * @param traversal - type of traversal (shallow/deep)
 */
export default function findConversationWithStartIndex(
    baseFolderId: BaseFolderId,
    startIndex: number,
    rowsToLoad: number,
    viewFilter: ViewFilter,
    sortResults: SortResults[],
    focusedViewFilter: FocusedViewFilter,
    findConversationShapeName: string,
    shouldTryToUseSessionDataResponse: boolean,
    categoryFilter?: string,
    traversal?: ConversationQueryTraversal
): Promise<FindConversationResponseMessage> {
    if (shouldTryToUseSessionDataResponse) {
        const sessionDataFindConversationResponse = tryConsumeFindConversationResponse(
            (baseFolderId as FolderId).Id,
            startIndex
        );
        if (sessionDataFindConversationResponse) {
            // Return the session data response if available instead of going to the server
            return new Promise<FindConversationResponseMessage>(resolve => {
                resolve(sessionDataFindConversationResponse);
            });
        }
    }

    const paging = indexedPageView({
        BasePoint: 'Beginning',
        Offset: 0 /* startIndex */,
        MaxEntriesReturned: rowsToLoad,
    });

    return findConversation(
        baseFolderId,
        paging,
        viewFilter,
        sortResults,
        focusedViewFilter,
        findConversationShapeName,
        categoryFilter,
        traversal
    ).then(logLoadedConversationIds);
}
